import { extend } from 'vee-validate'
import {
  required,
  required_if,
  excluded,
  numeric,
  max,
} from 'vee-validate/dist/rules'
import maxHankaku from './lib/max_hankaku'

// add vee-validate rules
const rules = {
  install(Vue) {
    extend('required', required)
    extend('required_if', required_if)
    extend('excluded', excluded)
    extend('numeric', numeric)
    extend('max', max)
    extend('max_hankaku', maxHankaku)
  }
}

export default rules
